function enforceCompetitorSelectionLimit() {
  $(".social-listening-competitor-chips").each(function() {
    var $group = $(this);
    var max = parseInt($group.data("max-competitors"), 10);
    if (!max) return;

    var $inputs = $group.find(".social-listening-competitor-chip input[type=checkbox]");
    var reachedLimit = $inputs.filter(":checked").length >= max;
    $inputs.each(function() {
      this.disabled = reachedLimit && !this.checked;
      $(this).closest(".social-listening-competitor-chip").toggleClass("disabled", this.disabled);
    });
  });
}

$(document)
  .on("click", ".js-platform-toggle", function() {
    $(this).toggleClass("active");
  })
  .on("change", ".social-listening-competitor-chip input[type=checkbox]", function() {
    enforceCompetitorSelectionLimit();
  })
  .on("click", ".js-run-social-listening", function(e) {
    e.preventDefault();

    if (window.trackPicoUserAction) {
      window.trackPicoUserAction('social_listening_run_button_clicked', {});
    }
    
    var $btn = $(this).prop("disabled", true);
    
    $.post({
      url: $btn.data("url"),
      dataType: "json",
      data: {
        competitor_ids: $(".social-listening-competitor-chip input:checked").map(function() { return this.value; }).get(),
        platform_ids: $(".js-platform-toggle.active").map(function() { return $(this).data("provider"); }).get()
      },
      headers: { "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content") }
    })
    .done(function(data) {
      if (data.show_brand_setup_modal && confirm("To run your first analysis, please setup your brand. Go to Brand Setup?")) {
        window.location.href = $btn.data("brand-setup-url");
      } else if (data.success) {
        $(".social-listening-competitor-chip input").prop("checked", false);
        enforceCompetitorSelectionLimit();
      }
    })
    .fail(function(xhr) {
      if (xhr.status === 402 && xhr.responseJSON?.code === "usage_limit_reached") return;
      alert(
        xhr.status === 409 ? "A social listening run is already in progress. Please wait for it to complete." :
        xhr.status === 422 && xhr.responseJSON?.error ? xhr.responseJSON.error :
        "An error occurred. Please try again."
      );
    })
    .always(function() {
      $btn.prop("disabled", false);
    });
  });

$(document).on("turbo:load", function() {
  var modal = $("#social-listening-welcome-modal");
  if (!modal.length) return;
  modal.modal("show");
  modal.on("hidden.bs.modal", function() {
    $.ajax({ url: "/user_acceptances", type: "POST", data: { code: "social_listening_welcome_202602" } });
  });
});

function scaleWordClouds() {
  document.querySelectorAll("[data-scale-to-fit]").forEach(function(el) {
    var parent = el.parentElement;
    if (!parent) return;
    el.style.transform = "scale(1)";
    el.style.width = parent.clientWidth + "px";
    el.style.transform = "scale(" + Math.min(parent.clientHeight / el.scrollHeight, 1).toFixed(3) + ")";
  });
}

function scrollToEndElements() {
  document.querySelectorAll("[data-scroll-to-end]").forEach(function(el) {
    el.scrollLeft = el.scrollWidth;
  });
}

["DOMContentLoaded", "turbo:load", "turbo:render"].forEach(function(evt) {
  document.addEventListener(evt, function() {
    scaleWordClouds();
    scrollToEndElements();
    enforceCompetitorSelectionLimit();
  });
});
